import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import usePluginEntities from "hooks/usePluginEntities";
const MessageTableProviders = ({ children }) => {
  const contextProviders = usePluginEntities("views.components.widgets.messageTable.contextProviders");
  if (!contextProviders || (contextProviders == null ? void 0 : contextProviders.length) === 0) {
    return children;
  }
  return contextProviders.reduce(
    (nestedChildren, MessageTableContextProvider) => /* @__PURE__ */ React.createElement(ErrorBoundary, { FallbackComponent: () => nestedChildren }, /* @__PURE__ */ React.createElement(MessageTableContextProvider, null, nestedChildren)),
    children
  );
};
export default MessageTableProviders;
